import { useEffect, useRef, useState } from "react";
import { TEXT_SMALL } from "../../../style";

const SUPERVISION_MESSAGE = "Make sure no one is in Your Surroundings & No one is Helping you";
const MIN_DELAY_MS = 15000;
const MAX_DELAY_MS = 45000;
const VISIBLE_MS = 8000;

const randomDelay = () => MIN_DELAY_MS + Math.floor(Math.random() * (MAX_DELAY_MS - MIN_DELAY_MS + 1));

export default function ExamLiveCameraPreview() {
    const videoRef = useRef(null);
    const streamRef = useRef(null);
    const [showSupervisionMessage, setShowSupervisionMessage] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const video = videoRef.current;

        const startPreview = async () => {
            if (!navigator.mediaDevices?.getUserMedia) {
                return;
            }

            try {
                let stream;
                try {
                    stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" }, audio: false });
                } catch {
                    stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
                }

                if (cancelled) {
                    stream.getTracks().forEach((track) => track.stop());
                    return;
                }

                streamRef.current = stream;

                if (video) {
                    video.srcObject = stream;
                    await video.play();
                }
            } catch {
                // Optional supervised preview during exam.
            }
        };

        startPreview();

        return () => {
            cancelled = true;
            streamRef.current?.getTracks().forEach((track) => track.stop());
            streamRef.current = null;
            if (video) {
                video.srcObject = null;
            }
        };
    }, []);

    useEffect(() => {
        let showTimeoutId;
        let hideTimeoutId;
        let cancelled = false;

        const scheduleShow = () => {
            showTimeoutId = setTimeout(() => {
                if (cancelled) return;
                setShowSupervisionMessage(true);
                hideTimeoutId = setTimeout(() => {
                    if (cancelled) return;
                    setShowSupervisionMessage(false);
                    scheduleShow();
                }, VISIBLE_MS);
            }, randomDelay());
        };

        scheduleShow();

        return () => {
            cancelled = true;
            clearTimeout(showTimeoutId);
            clearTimeout(hideTimeoutId);
        };
    }, []);

    return (
        <div className="flex flex-column align-items-start gap-1 flex-shrink-0">
            <div className="border-round border-1 border-gray-300 overflow-hidden bg-gray-900 w-8rem h-8rem">
                <video ref={videoRef} className="w-full h-full object-cover" playsInline muted autoPlay />
            </div>
            <span className={`${TEXT_SMALL} text-color-secondary`}>Assessment is getting supervised</span>
            {showSupervisionMessage && (
                <span className={`${TEXT_SMALL} text-orange-700 font-semibold fadein animation-duration-500 max-w-14rem`}>
                    {SUPERVISION_MESSAGE}
                </span>
            )}
        </div>
    );
}
